import { useEffect } from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import Process from "../components/Process";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import Contact from "../components/Contact";
import StickyActions from "../components/StickyActions";
import VisitorTracker from "../components/VisitorTracker";

const Home = () => {
  useEffect(() => {
    document.title = "CHAITRA ENTERPRISES - Property Registration & Legal Documentation";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <VisitorTracker />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <Process />
      <FAQ />
      <FinalCTA />
      <Contact />
      <StickyActions />
    </div>
  );
};

export default Home;
